// Services Firestore pour la galerie d'images générées
import { db, auth } from '../firebase/config';
import { addDoc, collection, serverTimestamp, doc, deleteDoc, getDocs, orderBy, query, updateDoc } from 'firebase/firestore';

export interface ImageRecord {
  url: string;
  filePath?: string | null;
  fileId?: string | null;
  name?: string | null;
  favorite?: boolean; // défaut false
  prompt?: string;
  dreamId?: string | null;
  width?: number;
  height?: number;
}

export interface ImageDoc extends ImageRecord { id: string; createdAt?: any }

export async function getUserImages(): Promise<ImageDoc[]> {
  const user = auth.currentUser;
  if (!user) throw new Error('Utilisateur non connecté');
  const colRef = collection(db, 'users', user.uid, 'images');
  // Tri décroissant par createdAt si présent
  const q = query(colRef, orderBy('createdAt', 'desc'));
  const snap = await getDocs(q);
  const items: ImageDoc[] = [];
  snap.forEach((d) => {
    const data = d.data() as any;
    items.push({
      id: d.id,
      url: data.url,
      filePath: data.filePath ?? null,
      fileId: data.fileId ?? null,
      name: data.name ?? null,
      favorite: data.favorite ?? false,
      prompt: data.prompt ?? '',
      dreamId: data.dreamId ?? null,
      width: data.width ?? null,
      height: data.height ?? null,
      createdAt: data.createdAt ?? null,
    });
  });
  return items;
}

export async function deleteImageRecord(docId: string): Promise<void> {
  const user = auth.currentUser;
  if (!user) throw new Error('Utilisateur non connecté');
  await deleteDoc(doc(db, 'users', user.uid, 'images', docId));
}

export async function saveImageRecord(record: ImageRecord): Promise<string> {
  const user = auth.currentUser;
  if (!user) throw new Error('Utilisateur non connecté');

  const docRef = await addDoc(
    collection(db, 'users', user.uid, 'images'),
    {
      url: record.url,
      filePath: record.filePath || null,
      fileId: record.fileId || null,
      name: record.name || null,
      favorite: record.favorite ?? false,
      prompt: record.prompt || '',
      dreamId: record.dreamId || null,
      width: record.width || null,
      height: record.height || null,
      createdAt: serverTimestamp(),
    }
  );
  return docRef.id;
}

export async function updateImageFavorite(docId: string, favorite: boolean): Promise<void> {
  const user = auth.currentUser;
  if (!user) throw new Error('Utilisateur non connecté');
  await updateDoc(doc(db, 'users', user.uid, 'images', docId), { favorite });
}
